import React, { useState,  useEffect} from 'react';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

import api from '../../common/apiService';
import { parseISO, format } from 'date-fns';
import _ from 'lodash';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Card,
  CardActions,
  CardContent,
  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  TablePagination,
  Chip,
  Button,
  Grid

} from '@material-ui/core';

import { Toolbar } from './components';
import config from '../../config/config.json'



const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  card : {
      width: '50%'
  }
}));

const ReportMoney = (props) => {
    const { className, ...rest } = props;
    const classes = useStyles();

    const [selectedStartDate, setSelectedStartDate] = useState(new Date());
    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [report, setReport] = useState([]);
    const [total, setTotal] = useState(0);


    const getData = async () => {
      const reportApi = await api.getMoneyReport(selectedStartDate,selectedEndDate);
      setReport(reportApi)
    //   console.log('reportApi',reportApi);
      setTotal(_.sumBy(reportApi, function(o) { return o.amount * config.currenciesRate[o.currency_id]; }));

    };

    useEffect(() => {
        // Получим списки сессий и пользователей
        getData();
      }, []);  


      const handleStartDateChange = date => {
        setSelectedStartDate(date);
      };
    
      const handleEndDateChange = date => {
        setSelectedEndDate(date);
      };
      
      const handleMakeReport = () => {
        getData();
      };
    

  return (
    <div className={classes.root}>
    <Toolbar 
        startDate={selectedStartDate}
        endDate={selectedEndDate}
        total={total}
        onStartDateChange={handleStartDateChange}
        onEndDateChange={handleEndDateChange}
        onMakeReport={handleMakeReport}

    />
    <div className={classes.content}>
    <Card
    //   {...rest}
      className={classes.card}
    >
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Валюта</TableCell>
                  <TableCell>Тип платежа</TableCell>
                  <TableCell>Сумма</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {/* {tickets.slice(0, rowsPerPage).map(user => ( */}
                {report.map((row, index) => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={index}
                  >
                    <TableCell>
                    {row.currency_name}
                    </TableCell>
                    <TableCell>
                    {row.paymenttype_name}
                    </TableCell>
                    <TableCell>
                    {`${row.amount.toLocaleString('ru')} ${_.filter(config.currencies, ['value', row.currency_id])[0].label}`}
                    </TableCell>

                  </TableRow>
                 ))} 
              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>
    </Card>
    </div>
    </div>
  );
};

export default ReportMoney;